<template>
	<div>
		<b-navbar toggleable="lg" variant="faded" type="light" fixed="top" class="pb-0">
			<b-navbar-brand to="/">
				<img src="@/assets/images/BI.svg" alt="Logo Bravo Izquierdo" class="logo">
			</b-navbar-brand>
			<b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
			<b-collapse id="nav-collapse" is-nav>
				<b-navbar-nav class="ml-auto d-none d-lg-block">
					<b-table-simple borderless condensed class="text-right my-0">
						<b-tr>
							<b-td style="color: #B12424" class="py-3">
								<strong>@bravo</strong>izquierdocl
								
								<b-link href="https://www.facebook.com/bravoizquierdocl" target="_blank">
									<font-awesome-layers class="fa-lg mx-1">
										<font-awesome-icon :icon="['fas', 'circle']" style="color: #B12424" />
										<font-awesome-icon :icon="['fab', 'facebook-f']" transform="shrink-6" class="text-white" />
									</font-awesome-layers>
								</b-link>
								<b-link href="https://www.instagram.com/bibravoizquierdo/" target="_blank">
									<font-awesome-layers class="fa-lg">
										<font-awesome-icon :icon="['fas', 'circle']" style="color: #B12424" />
										<font-awesome-icon :icon="['fab', 'instagram']" transform="shrink-6" class="text-white" />
									</font-awesome-layers>
								</b-link>
								<b-link href="https://www.linkedin.com/company/bravo-izquierdo/" target="_blank">
									<font-awesome-layers class="fa-lg mx-1">
										<font-awesome-icon :icon="['fas', 'circle']" style="color: #B12424;" />
										<font-awesome-icon :icon="['fab', 'linkedin']" transform="shrink-6" class="text-white" style="font-size:20px" />
									</font-awesome-layers>
								</b-link>
								<b-link href="https://www.youtube.com/channel/UChKwaxagm1960GydfTLNecQ" target="_blank">
									<font-awesome-layers class="fa-lg mx-1">
										<font-awesome-icon :icon="['fas', 'circle']" style="color: #B12424;" />
										<font-awesome-icon :icon="['fab', 'youtube']" transform="shrink-6" class="text-white" style="font-size:20px" />
									</font-awesome-layers>
								</b-link>
							</b-td>
						</b-tr>
						<b-tr class="">
							<b-td class="py-0">
								<b-button squared variant="bravoizq" size="sm" class="my-2 my-sm-0 btn-br border-left-br" type="button" @click="goTo('home', {scrollTo: '#sell-project'})">En Venta</b-button>
								<b-button squared variant="bravoizq" size="sm" class="my-2 my-sm-0 btn-br border-left-br" type="button" :to="{name: 'coming' }">Próximamente</b-button>
								<b-button squared variant="bravoizq" size="sm" class="my-2 my-sm-0 btn-br border-left-br" :href="$store.state.clientURL">Mi cuenta</b-button>
							</b-td>
						</b-tr>
					</b-table-simple>
				</b-navbar-nav>
				<b-navbar-nav class="d-lg-none text-left p-4">
					<b-nav-item link-classes="btn btn-bravoizq text-white rounded-0 border-bottom-br" @click="goTo('home', {scrollTo: '#sell-project'})">En Venta</b-nav-item>
					<b-nav-item link-classes="btn btn-bravoizq text-white rounded-0 border-bottom-br" :to="{name: 'coming' }">Próximamente</b-nav-item>
					<b-nav-item link-classes="btn btn-bravoizq text-white rounded-0" :href="$store.state.clientURL">Mí Cuenta</b-nav-item>
					<b-table-simple borderless condensed class="text-right my-0">
						<b-tr>
							<b-td style="color: #B12424" class="py-3">
								<strong>@bravo</strong>izquierdocl
								<b-link href="https://www.facebook.com/bravoizquierdocl" target="_blank">
									<font-awesome-layers class="fa-lg mx-1">
										<font-awesome-icon :icon="['fas', 'circle']" style="color: #B12424" />
										<font-awesome-icon :icon="['fab', 'facebook-f']" transform="shrink-6" class="text-white" />
									</font-awesome-layers>
								</b-link>
								<b-link href="https://www.instagram.com/bibravoizquierdo/" target="_blank">
									<font-awesome-layers class="fa-lg">
										<font-awesome-icon :icon="['fas', 'circle']" style="color: #B12424" />
										<font-awesome-icon :icon="['fab', 'instagram']" transform="shrink-6" class="text-white" />
									</font-awesome-layers>
								</b-link>
								<b-link href="https://www.linkedin.com/company/bravo-izquierdo/" target="_blank">
									<font-awesome-layers class="fa-lg">
										<font-awesome-icon :icon="['fas', 'circle']" style="color: #B12424" />
										<font-awesome-icon :icon="['fab', 'linkedin']" transform="shrink-6" class="text-white" />
									</font-awesome-layers>
								</b-link>
								<b-link href="https://www.youtube.com/channel/UChKwaxagm1960GydfTLNecQ" target="_blank">
									<font-awesome-layers class="fa-lg">
										<font-awesome-icon :icon="['fas', 'circle']" style="color: #B12424" />
										<font-awesome-icon :icon="['fab', 'youtube']" transform="shrink-6" class="text-white" />
									</font-awesome-layers>
								</b-link>
							</b-td>
						</b-tr>
					</b-table-simple>
				</b-navbar-nav>
			</b-collapse>
		</b-navbar>
	</div>
</template>
<script>
	export default {
		name: 'NavBar',
		methods: {
			scrollToElem(elemName) {
				window.scroll({
					top: document.querySelector(elemName).offsetTop,
					behavior: 'smooth'
				});
			},
			goTo(url, params){
				if(this.$route.name == url && params.scrollTo){
					this.scrollToElem(params.scrollTo);
				}else{
					if(this.$route.name != url){
						this.$router.push({ name: url, params: params }).catch(err => { console.log('ERROR:',err) });
					}
				}
			}
		}
	}
</script>
<style>
	.btn-br{
		background: #b12525 !important;
		color: white !important;
		border-radius: 1px;
		box-shadow: none !important;
		padding: 10px 20px !important;
	}
	.navbar {
		background: rgba(183, 183, 183, 0.66);
		z-index: 1000;
	}
	.logo{
		width: 90px;
		margin-left: 45px;
	}
</style>
